import { render, staticRenderFns } from "./ExchangeCode.vue?vue&type=template&id=b80f3216&scoped=true&"
import script from "./ExchangeCode.vue?vue&type=script&lang=js&"
export * from "./ExchangeCode.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeCode.vue?vue&type=style&index=0&id=b80f3216&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80f3216",
  null
  
)

export default component.exports